"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWujiUrl = exports.post = exports.get = void 0;
const axios_1 = __importDefault(require("axios"));
const util_1 = require("./util");
function fetch(data) {
    if (!data.url) {
        return Promise.reject({
            errType: 'js_err',
        });
    }
    return new Promise((resolve, reject) => {
        if (!Object.prototype.hasOwnProperty.call(data, 'withCredentials')) {
            data.withCredentials = true;
        }
        if (!data.timeout) {
            data.timeout = 5000;
        }
        axios_1.default(data)
            .then(({ data, status }) => {
            if (status === 200) {
                return resolve(data);
            }
            if ([404].indexOf(status) >= 0) {
                return reject({
                    errType: 'net_err',
                });
            }
            return reject({
                errType: 'serv_err',
            });
        })
            .catch(e => {
            return reject({
                errType: 'unknown_err',
                errInfo: e,
            });
        });
    });
}
exports.default = fetch;
function get(data, config) {
    return fetch(Object.assign({
        method: 'get',
    }, data, config || {}));
}
exports.get = get;
function post(data, config) {
    return fetch(Object.assign({ method: 'post' }, data, config || {}));
}
exports.post = post;
const WUJI_DOMAIN = 'wujicdn.wetvinfo.com';
function getWujiUrl(_a) {
    var { id = '', schemaid = '', schemakey = '', appid = 'WeTV_Web' } = _a, rest = __rest(_a, ["id", "schemaid", "schemakey", "appid"]);
    if (!schemaid) {
        return '';
    }
    return `https://${WUJI_DOMAIN}/cache/wuji/object${id ? `/${id}` : ''}?${util_1.convertQueryToString(Object.assign({ schemakey,
        schemaid,
        appid }, rest))}`;
}
exports.getWujiUrl = getWujiUrl;
